import { Environments } from '../../types/global';
export const BTC = {
    explorer: {
        [Environments.Mainnet]: 'https://mempool.space',
        [Environments.Testnet]: 'https://mempool.space/testnet',
    },
};
